export const SelfAssessmentApi = {
  GET_API: '/self_evaluations',
  GET_API_SCHOOL: '/self_evaluations/so',
  UPDATE_SELF_EVALUATION: '/self_evaluations/save_evaluation/so'
};
